import axios from 'axios'
import { attachAuthInterceptors } from '@adthlete/shared-frontend'

const api = axios.create({
  baseURL: '/api',
})

// Inject the in-memory access token and refresh-and-retry once on a 401 from a protected
// endpoint. Refresh failure clears user state via the onAuthCleared hook wired in App.tsx.
attachAuthInterceptors(api, { appId: 'marketer' })

export default api
